{
  "familyId": "SWW-TT-ZIJN-HEBBEN",
  "questions": [
    {
      "id": "SWW-TT-ZIJN-HEBBEN-001",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Hij ... een grote hond.'",
      "context": "Op het schoolplein vertelt Sem trots: 'Mijn buurman heeft een huisdier.' Welke vorm past?",
      "options": ["heeft", "is", "heb", "zijn"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn vs. Hebben", "content": "Regel: gebruik 'hebben' bij bezit (iets dat je hebt): hij heeft een hond. Gebruik 'zijn' bij eigenschappen of toestand: hij is groot. Vervoeging hebben: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_bezit",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Stap 1: bezit of eigenschap? Een hond is BEZIT (iets dat je hebt) → werkwoord 'hebben'. Stap 2: vervoeging bij 'hij' (enkelvoud) = 'heeft'. Antwoord: hij heeft een grote hond. Checkstrategie: vraag jezelf 'kun je het bezitten?' Ja → hebben. Nee → zijn.",
        "solutionSteps": [
          "Stap 1 — Bepaal het onderwerp: hij (enkelvoud)",
          "Stap 2 — Bezit of eigenschap? Een hond = bezit → hebben",
          "Stap 3 — Vervoeging bij 'hij' (3e persoon enkelvoud) = heeft",
          "Antwoord: hij heeft een grote hond"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Heeft' gebruik je bij bezit: hij heeft een hond.",
          "1": "Je dacht waarschijnlijk dat 'is' hier past. Maar 'is' gebruik je voor eigenschappen of toestand (hij is groot, hij is ziek). Een hond is iets wat je bezit, dus gebruik je 'heeft'. Onthoud: bezit = hebben, eigenschap = zijn.",
          "2": "Je dacht waarschijnlijk dat 'heb' de juiste vorm is. Maar 'heb' gebruik je bij 'ik': ik heb een hond. Bij 'hij' gebruik je 'heeft'. Onthoud: ik heb, jij hebt, hij/zij heeft.",
          "3": "Je dacht waarschijnlijk dat 'zijn' past. Maar 'zijn' is de meervoudsvorm (wij zijn, zij zijn). Bij 'hij' gebruik je 'is' of 'heeft'. Onthoud: hij = enkelvoud, dus niet 'zijn'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-verward-bezit", "label": "Zijn gebruikt bij bezit", "optionIndex": 1 },
          { "id": "sww.zijnhebben-persoon-verward", "label": "Ik-vorm gebruikt bij hij", "optionIndex": 2 },
          { "id": "sww.zijnhebben-meervoud-bij-enkelvoud", "label": "Meervoudsvorm gebruikt bij enkelvoud onderwerp", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-002",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm is correct?\n'Zij ... heel blij vandaag.'",
      "context": "Tess heeft net een hoge cijfer gehaald en lacht de hele dag. Welke vorm past in de zin?",
      "options": ["is", "heeft", "zijn", "heb"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn vs. Hebben", "content": "Regel: gebruik 'zijn' bij eigenschappen, gevoelens en toestanden: zij is blij, hij is ziek, het is koud. Gebruik 'hebben' bij bezit: zij heeft een fiets. Vervoeging zijn: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_eigenschap",
      "variantIndex": 2,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: bezit of eigenschap? 'Blij' is een GEVOEL/EIGENSCHAP → werkwoord 'zijn'. Stap 2: vervoeging bij 'zij' (enkelvoud) = 'is'. Antwoord: zij is blij. Checkstrategie: vraag jezelf 'is het iets dat je voelt of hoe je bent?' Ja → zijn.",
        "solutionSteps": [
          "Stap 1 — Bepaal het onderwerp: zij (enkelvoud)",
          "Stap 2 — Bezit of eigenschap? Blij = gevoel → zijn",
          "Stap 3 — Vervoeging bij 'zij' (enkelvoud) = is",
          "Antwoord: zij is heel blij vandaag"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Is' gebruik je bij eigenschappen en gevoelens: zij is blij.",
          "1": "Je dacht waarschijnlijk dat 'heeft' hier past. Maar 'heeft' gebruik je bij bezit (zij heeft een fiets). 'Blij' is een eigenschap, dus gebruik je 'is': zij is blij. Onthoud: gevoel/eigenschap = zijn.",
          "2": "Je dacht waarschijnlijk dat 'zijn' de juiste vorm is. Maar 'zijn' is de meervoudsvorm (wij zijn blij, zij zijn blij). Bij enkelvoud 'zij' (één persoon) gebruik je 'is'. Onthoud: zij (1 persoon) = is, zij (meerdere) = zijn.",
          "3": "Je dacht waarschijnlijk dat 'heb' past. Maar 'heb' gebruik je bij 'ik': ik heb. Bij 'zij' gebruik je 'is' of 'heeft'. Onthoud: ik heb, jij hebt, hij/zij heeft."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-verward-gevoel", "label": "Hebben gebruikt bij gevoel/eigenschap", "optionIndex": 1 },
          { "id": "sww.zijnhebben-enkelvoud-meervoud", "label": "Meervoud zijn-vorm gebruikt bij enkelvoud", "optionIndex": 2 },
          { "id": "sww.zijnhebben-persoon-verward", "label": "Ik-vorm gebruikt bij zij", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-003",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "context": "In de klas vertellen kinderen over hun huisdieren. Welke zin staat foutloos op het bord?",
      "options": [
        "Wij heeft twee katten.",
        "Wij hebben twee katten.",
        "Wij zijn twee katten.",
        "Wij heb twee katten."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Vervoeging zijn en hebben", "content": "HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben. ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn. Bij 'wij' altijd de meervoudsvorm.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_meervoud",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Stap 1: bezit of eigenschap? Katten zijn BEZIT → werkwoord 'hebben'. Stap 2: vervoeging bij 'wij' (meervoud) = 'hebben'. Antwoord: wij hebben twee katten. Overzicht: ik heb, jij hebt, hij/zij heeft, wij/jullie/zij hebben.",
        "solutionSteps": [
          "Stap 1 — Bepaal het onderwerp: wij (meervoud)",
          "Stap 2 — Bezit of eigenschap? Katten = bezit → hebben",
          "Stap 3 — Vervoeging bij 'wij' (meervoud) = hebben",
          "Antwoord: wij hebben twee katten"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 'heeft' bij 'wij' hoort. Maar 'heeft' gebruik je bij 'hij/zij/het' (enkelvoud). Bij 'wij' gebruik je 'hebben'. Onthoud: wij/jullie/zij → hebben.",
          "1": "Correct! Bij 'wij' gebruik je 'hebben': wij hebben twee katten.",
          "2": "Je dacht waarschijnlijk dat 'zijn' hier past. Maar 'zijn' gebruik je bij eigenschappen/toestand. Katten zijn iets wat je bezit, dus gebruik je 'hebben'. Onthoud: bezit = hebben.",
          "3": "Je dacht waarschijnlijk dat 'heb' bij 'wij' hoort. Maar 'heb' gebruik je bij 'ik': ik heb. Bij 'wij' gebruik je 'hebben'. Onthoud: ik heb, wij hebben."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-enkelvoud-meervoud", "label": "Enkelvoud heeft gebruikt bij meervoud wij", "optionIndex": 0 },
          { "id": "sww.zijnhebben-verward-bezit", "label": "Zijn gebruikt bij bezit", "optionIndex": 2 },
          { "id": "sww.zijnhebben-persoon-verward", "label": "Ik-vorm 'heb' gebruikt bij wij", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-004",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke vorm past in de zin?\n'Ik ... moe na het sporten.'",
      "context": "Na een lange voetbalwedstrijd ploft Daan op de bank. Hoe maakt hij de zin af?",
      "options": ["ben", "heb", "is", "zijn"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Vervoeging zijn", "content": "ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn. Moe is een toestand/eigenschap → gebruik zijn.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_ik_ben",
      "variantIndex": 4,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: bezit of eigenschap? 'Moe' is een TOESTAND → werkwoord 'zijn'. Stap 2: vervoeging bij 'ik' = 'ben'. Antwoord: ik ben moe. Vervoeging zijn: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn.",
        "solutionSteps": [
          "Stap 1 — Bepaal het onderwerp: ik",
          "Stap 2 — Bezit of eigenschap? Moe = toestand → zijn",
          "Stap 3 — Vervoeging bij 'ik' = ben",
          "Antwoord: ik ben moe na het sporten"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Moe' is een toestand, dus gebruik je 'zijn'. Bij 'ik' is dat: ik ben moe.",
          "1": "Je dacht waarschijnlijk dat 'heb' hier past. Maar 'heb' gebruik je bij bezit (ik heb een fiets). 'Moe' is een toestand, dus gebruik je 'ben': ik ben moe. Onthoud: toestand/gevoel = zijn.",
          "2": "Je dacht waarschijnlijk dat 'is' bij 'ik' hoort. Maar 'is' gebruik je bij 'hij/zij/het': hij is moe. Bij 'ik' gebruik je 'ben': ik ben moe. Onthoud: ik ben, hij is.",
          "3": "Je dacht waarschijnlijk dat 'zijn' bij 'ik' hoort. Maar 'zijn' gebruik je bij 'wij/jullie/zij': wij zijn moe. Bij 'ik' gebruik je 'ben': ik ben moe. Onthoud: ik ben, wij zijn."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-verward-gevoel", "label": "Hebben gebruikt bij toestand/gevoel", "optionIndex": 1 },
          { "id": "sww.zijnhebben-persoon-verward", "label": "Hij-vorm 'is' gebruikt bij ik", "optionIndex": 2 },
          { "id": "sww.zijnhebben-enkelvoud-meervoud", "label": "Meervoudsvorm 'zijn' gebruikt bij ik", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-005",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "multiple_choice",
      "question": "Welke zin is FOUT?",
      "context": "Op een proefwerk staan vier zinnen. Drie zijn goed — welke is fout?",
      "options": [
        "Jij hebt een mooie jas.",
        "Hij is ziek.",
        "Wij zijn vrolijk.",
        "Jullie is op vakantie."
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Vervoeging zijn", "content": "ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn. Bij 'jullie' gebruik je altijd 'zijn', niet 'is'.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_fout_vinden",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Stappenplan: controleer elke zin op (1) zijn/hebben-keuze en (2) juiste vervoeging bij het onderwerp. 'Jullie is op vakantie' is fout: 'jullie' is meervoud, dus 'zijn' (jullie zijn op vakantie). Vervoeging zijn: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn.",
        "solutionSteps": [
          "Stap 1 — Controleer elke zin op de juiste vorm van zijn/hebben",
          "Stap 2 — 'Jullie is' → jullie = meervoud, 'is' = enkelvoud → fout",
          "Stap 3 — Bij 'jullie' hoort 'zijn': jullie zijn op vakantie",
          "Antwoord: 'Jullie is op vakantie' is FOUT"
        ],
        "distractorExplanations": {
          "0": "Deze zin is correct: 'jij hebt' is de juiste vorm van 'hebben' bij 'jij'. Onthoud: ik heb, jij hebt, hij heeft.",
          "1": "Deze zin is correct: 'hij is' is de juiste vorm van 'zijn' bij 'hij'. 'Ziek' is een toestand → zijn.",
          "2": "Deze zin is correct: 'wij zijn' is de juiste meervoudsvorm van 'zijn'. 'Vrolijk' is een eigenschap → zijn.",
          "3": "Correct gevonden! 'Jullie is' is fout. Bij 'jullie' gebruik je 'zijn': jullie zijn op vakantie. Onthoud: jullie = meervoud → zijn."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Correcte 'jij hebt' aangezien als fout", "optionIndex": 0 },
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Correcte 'hij is' aangezien als fout", "optionIndex": 1 },
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Correcte 'wij zijn' aangezien als fout", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-006",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: 'Wij ... (zijn/hebben) heel veel huiswerk.' Typ het woord.",
      "context": "Na een drukke schooldag klagen de leerlingen tegen elkaar.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["hebben"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Zijn of hebben?", "content": "Huiswerk is iets wat je bezit/hebt. Bij bezit gebruik je 'hebben'. Bij 'wij' is de vorm: hebben.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Stap 1: huiswerk is iets wat je hebt (bezit) → werkwoord 'hebben'. Stap 2: bij 'wij' (meervoud) = 'hebben'. Antwoord: wij hebben heel veel huiswerk.",
        "solutionSteps": [
          "Stap 1 — Huiswerk = bezit → werkwoord hebben",
          "Stap 2 — Wij = meervoud → hebben",
          "Antwoord: wij hebben"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-verward-bezit", "label": "Zijn gekozen bij bezit (huiswerk)" }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-007",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij 'zijn' of 'hebben'? Klik op de fout.",
      "context": "Vier kinderen lezen hun zin voor. Eentje maakt een fout in de werkwoordsvorm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Hij hebben een nieuwe fiets.", "hasError": true, "correction": "heeft", "explanation": "Bij 'hij' (enkelvoud) gebruik je 'heeft', niet 'hebben'. 'Hebben' is de meervoudsvorm." },
          { "text": "Wij zijn heel blij.", "hasError": false },
          { "text": "Ik heb een broer en een zus.", "hasError": false },
          { "text": "Zij is vandaag jarig.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Vervoegingen van hebben", "content": "HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben. Bij 'hij' gebruik je 'heeft', niet 'hebben'.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "zijn_hebben_error",
      "variantIndex": 7,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Stappenplan: voor elke zin check je (1) wie is het onderwerp (enkelvoud/meervoud), (2) past de werkwoordsvorm? 'Hij hebben' is fout: 'hij' is enkelvoud → 'heeft'. 'Hebben' is meervoud (wij/jullie/zij hebben).",
        "solutionSteps": [
          "Stap 1 — Hij hebben → hij = enkelvoud → moet 'heeft' zijn (FOUT)",
          "Stap 2 — Wij zijn → meervoud + eigenschap → goed",
          "Stap 3 — Ik heb → ik + bezit → goed",
          "Stap 4 — Zij is → enkelvoud + eigenschap (jarig) → goed"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-enkelvoud-meervoud", "label": "Meervoudsvorm 'hebben' gebruikt bij enkelvoud 'hij'" },
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Correcte vormen aangezien als fout" }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-008",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout bij 'zijn' of 'hebben'? Klik op de foute zin.",
      "context": "Een klasgenoot vraagt jou om hun zinnen te checken.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Ik ben heel hongerig.", "hasError": false },
          { "text": "Jij heb een mooie tas.", "hasError": true, "correction": "hebt", "explanation": "Bij 'jij' is de vorm 'hebt', niet 'heb'. Moet zijn: jij hebt een mooie tas. 'Heb' hoort bij 'ik'." },
          { "text": "Wij zijn altijd op tijd.", "hasError": false },
          { "text": "Hij heeft drie broers.", "hasError": false },
          { "text": "Zij heeft veel boeken.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee checks per zin",
            "content": "Check 1: is het bezit (→ hebben) of een eigenschap/toestand (→ zijn)? Check 2: past de vervoeging bij het onderwerp? HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben. ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zijn_hebben_fout_zoeken",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Controleer per zin: stap 1 (bezit → hebben, eigenschap/toestand → zijn) en stap 2 (past de vervoeging bij het onderwerp?). De foute zin is 'Jij heb een mooie tas': bij 'jij' is de vorm 'hebt' (jij-vorm = stam + t), niet 'heb'. 'Heb' hoort bij 'ik'. De andere zinnen kloppen.",
        "solutionSteps": [
          "Per zin: bezit (→ hebben) of eigenschap (→ zijn)?",
          "Daarna: past de vervoeging bij het onderwerp?",
          "jij heb → fout (moet jij hebt; 'heb' hoort bij ik)",
          "De overige zinnen (ik ben, wij zijn, hij heeft, zij heeft) kloppen"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-persoon-verward", "label": "Ik-vorm 'heb' gebruikt bij jij" },
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Correcte vorm als fout beoordeeld" }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-009",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "matching",
      "question": "Koppel elk onderwerp aan de juiste vorm van 'zijn' of 'hebben'.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "ik (zijn)", "right": "ben" },
          { "left": "jij (hebben)", "right": "hebt" },
          { "left": "hij (zijn)", "right": "is" },
          { "left": "wij (hebben)", "right": "hebben" },
          { "left": "jullie (zijn)", "right": "zijn" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vervoegingsoverzicht",
            "content": "ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn. HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zijn_hebben_matching",
      "variantIndex": 9,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Vervoegingstabellen toepassen. ZIJN: ik ben, jij bent, hij/zij/het is, wij/jullie/zij zijn. HEBBEN: ik heb, jij hebt, hij/zij/het heeft, wij/jullie/zij hebben.",
        "solutionSteps": [
          "Ik + zijn = ben",
          "Jij + hebben = hebt",
          "Hij + zijn = is",
          "Wij + hebben = hebben",
          "Jullie + zijn = zijn"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-persoon-verward", "label": "Persoonsvorm verkeerd gekoppeld aan onderwerp" },
          { "id": "sww.zijnhebben-enkelvoud-meervoud", "label": "Enkelvoud/meervoud vorm verwisseld" }
        ]
      }
    },
    {
      "id": "SWW-TT-ZIJN-HEBBEN-010",
      "familyId": "SWW-TT-ZIJN-HEBBEN",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_zijn_hebben",
      "questionType": "categorize",
      "question": "Sorteer: hoort er 'zijn' of 'hebben' bij?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Zijn (eigenschap/toestand)", "Hebben (bezit)"],
        "items": [
          { "text": "boos", "correctCategory": 0 },
          { "text": "een fiets", "correctCategory": 1 },
          { "text": "vrolijk", "correctCategory": 0 },
          { "text": "drie pennen", "correctCategory": 1 },
          { "text": "ziek", "correctCategory": 0 },
          { "text": "honger", "correctCategory": 1 },
          { "text": "een nieuw boek", "correctCategory": 1 },
          { "text": "moe", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vraag jezelf af",
            "content": "Is het iets dat je voelt of hoe je BENT? → zijn. Is het iets dat je HEBT (bezit)? → hebben. Let op: 'honger' en 'dorst' nemen 'hebben': ik heb honger (niet ik ben honger).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "zijn_hebben_categorize",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Vraag jezelf: 'is het iets dat ik BEN/voel?' (→ zijn) of 'is het iets dat ik HEB?' (→ hebben). Eigenschappen en toestanden (boos, vrolijk, ziek, moe) gaan met zijn. Concrete dingen (fiets, pennen, boek) en uitdrukkingen als 'honger' gaan met hebben.",
        "solutionSteps": [
          "Stap 1 — Bezit / concrete dingen → hebben",
          "Stap 2 — Eigenschappen, gevoelens, toestanden → zijn",
          "Let op: 'honger' en 'dorst' = hebben (ik heb honger)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.zijnhebben-verward-bezit", "label": "Bezit aangezien voor eigenschap" },
          { "id": "sww.zijnhebben-verward-gevoel", "label": "Gevoel/toestand aangezien voor bezit" }
        ]
      }
    }
  ]
}